var _a;
import { __decorate, __metadata, __param } from "tslib";
import { AbstractPaginatedEntities, ApiPaginated } from '@cores/services/pagination';
import { injectable, inject, named } from 'inversify';
let PaginatedCommentsImp = class PaginatedCommentsImp extends AbstractPaginatedEntities {
    constructor(apiPaginated) {
        super();
        this.apiPaginated = apiPaginated;
    }
};
PaginatedCommentsImp = __decorate([
    injectable(),
    __param(0, inject(ApiPaginated)),
    __param(0, named('paginated-comments')),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiPaginated !== "undefined" && ApiPaginated) === "function" ? _a : Object])
], PaginatedCommentsImp);
export { PaginatedCommentsImp };
